import {AmlDocumentationPage} from '../pages/Software/docs/AmlDocumentationPage';
import {SystemModelGuidePage} from '../pages/Software/docs/SystemModelGuidePage';
import {LegalPage} from '../auth/LegalPage'
import { AuthProvider, AccountGate } from '../auth/AuthProvider'
import { SignInPage, CompleteProfilePage, PasswordPage } from '../auth/AccountPages'
import { lazy, Suspense, useEffect } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { SiteLayout } from '../components/layout/SiteLayout'
import { HomePage } from '../pages/Home/HomePage'
import { SoftwarePage } from '../pages/Software/SoftwarePage'
import { DeveloperToolPage } from '../pages/Software/DeveloperToolPage'
import { SoftwareAccessPage, SoftwareReleasePage } from '../pages/Software/SoftwareAccessPage'
import { SoftwareProductPage } from '../pages/Software/SoftwareProductPage'
import { developerTools, softwareProducts } from '../pages/Software/productData'
import { TechnologyDetailPage } from '../pages/Technology/TechnologyDetailPage'
import { TechnologyPage } from '../pages/Technology/TechnologyPage'
import { TechnologyResearchPage } from '../pages/Technology/TechnologyResearchPage'
import { technologyDetails } from '../data/technologies'
import { EngineeringDetailPage } from '../pages/Engineering/EngineeringDetailPage'
import { EngineeringPage } from '../pages/Engineering/EngineeringPage'
import { engineeringDetails } from '../data/engineering'
import { DataRoomPage } from '../pages/Investors/DataRoomPage'
import { InvestorMaterialsPage } from '../pages/Investors/InvestorMaterialsPage'
import { InvestorsPage } from '../pages/Investors/InvestorsPage'
import { AboutPage } from '../pages/About/AboutPage'
import { ShopCartPage, ShopCheckoutPage } from '../pages/Shop/ShopCartPage'
import { ShopPage } from '../pages/Shop/ShopPage'
import { ShopProductPage } from '../pages/Shop/ShopProductPage'
import { CartProvider } from '../context/CartContext'
import { PlaceholderPage } from '../pages/Placeholder/PlaceholderPage'
import { routes } from '../data/navigation'
import {LegacyNotebookRoute} from '../pages/Notebook/environment/LegacyNotebookRoute'
const SharedHome=lazy(()=>import('../aee/sharing/SharedHome').then(m=>({default:m.SharedHome})))
const InvitationPage=lazy(()=>import('../aee/sharing/SharedHome').then(m=>({default:m.InvitationPage})))
const SharedFilePage=lazy(()=>import('../aee/sharing/SharedFilePage').then(m=>({default:m.SharedFilePage})))
const LocalWorkspace = lazy(() => import('../aee/LocalWorkspace').then(module => ({ default: module.LocalWorkspace })))
const CloudHome = lazy(() => import('../aee/CloudHome').then(module => ({ default: module.CloudHome })))
const ProjectRoute = lazy(() => import('../aee/CloudProject').then(module => ({ default: module.ProjectRoute })))
const AEIWorkspacePage = lazy(() => import('../aee/ai/AEIWorkspacePage').then(module => ({ default: module.AEIWorkspacePage })))
import { ProfilePage } from '../pages/Notebook/ProfilePage'
import { NotebookBoundary } from '../pages/Notebook/NotebookBoundary'

const NotebookPage = lazy(() => import('../pages/Notebook/NotebookPage').then(module => ({ default: module.NotebookPage })))

function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }, [pathname])

  return null
}

export function App() {
  return (
    <AuthProvider><CartProvider>
      <ScrollToTop />
      <Routes>
        <Route path="/legal/terms" element={<LegalPage type="terms" key="terms"/>}/>
        <Route path="/legal/privacy" element={<LegalPage type="privacy" key="privacy"/>}/>
        <Route path="/account/forgot" element={<PasswordPage key="forgot" />} />
        <Route path="/account/verify" element={<PasswordPage key="verify" />} />
        <Route path="/account/reset" element={<PasswordPage key="reset" />} />
        <Route path="/signin" element={<SignInPage />} />
        <Route path="/account/create" element={<SignInPage />} />
        <Route path="/signup" element={<SignInPage />} />
        <Route element={<AccountGate />}>
        <Route path="/complete-profile" element={<CompleteProfilePage />} />
        <Route path="/notebook" element={<NotebookBoundary><Suspense fallback={<div style={{ minHeight: '100vh', background: '#f4f4f4', color: '#202124', padding: 48 }}>Opening Notebook…</div>}><NotebookPage /></Suspense></NotebookBoundary>} />
        <Route path="/notebook/*" element={<NotebookBoundary><Suspense fallback={<div style={{ minHeight: '100vh', background: '#f4f4f4', color: '#202124', padding: 48 }}>Opening Notebook…</div>}><NotebookPage /></Suspense></NotebookBoundary>} />
        <Route path="/notebook/project/:projectId" element={<LegacyNotebookRoute/>} />
        <Route path="/notebook/project/:projectId/page/:pageId" element={<LegacyNotebookRoute/>} />
        <Route path="/app" element={<Suspense fallback={<p>Opening projects…</p>}><CloudHome /></Suspense>} />
        <Route path="/app/local" element={<NotebookBoundary><Suspense fallback={<p>Opening local projects…</p>}><LocalWorkspace /></Suspense></NotebookBoundary>} />
        <Route path="/app/shared" element={<Suspense fallback={<p>Opening shared files…</p>}><SharedHome/></Suspense>}/>
        <Route path="/app/shared/:fileId" element={<NotebookBoundary><Suspense fallback={<p>Opening shared file…</p>}><SharedFilePage/></Suspense></NotebookBoundary>}/>
        <Route path="/app/invitations/:token" element={<Suspense fallback={<p>Opening invitation…</p>}><InvitationPage/></Suspense>}/>
        <Route path="/app/profile" element={<ProfilePage />} />
        <Route path="/app/ai" element={<Suspense fallback={<p>Opening AEI…</p>}><AEIWorkspacePage /></Suspense>} />
        <Route path="/app/ai/conversation/:conversationId" element={<Suspense fallback={<p>Opening AEI…</p>}><AEIWorkspacePage /></Suspense>} />
        <Route path="/app/projects" element={<Navigate to="/app" replace />} />
        <Route path="/app/project/:projectId" element={<NotebookBoundary><Suspense fallback={<p>Opening project…</p>}><ProjectRoute /></Suspense></NotebookBoundary>} />
        <Route path="/app/project/:projectId/:workspace/:entityId?" element={<NotebookBoundary><Suspense fallback={<p>Opening workspace…</p>}><ProjectRoute /></Suspense></NotebookBoundary>} />
        </Route>
        <Route element={<SiteLayout />}>
          <Route index element={<HomePage />} />
          <Route path="/software" element={<SoftwarePage />} />
          <Route path="/software/aldapanucore" element={<SoftwareProductPage product={softwareProducts.aldapanucore} />} />
          <Route path="/software/aldapanucore/download" element={<SoftwareAccessPage product={softwareProducts.aldapanucore} />} />
          <Route path="/software/aldapanucore/releases" element={<SoftwareReleasePage product={softwareProducts.aldapanucore} />} />
          <Route path="/software/nuspectra" element={<SoftwareProductPage product={softwareProducts.nuspectra} />} />
          <Route path="/software/nuspectra/download" element={<SoftwareAccessPage product={softwareProducts.nuspectra} />} />
          <Route path="/software/nuspectra/releases" element={<SoftwareReleasePage product={softwareProducts.nuspectra} />} />
          <Route path="/software/numath" element={<DeveloperToolPage tool={developerTools.numath} />} />
          <Route path="/software/aml" element={<AmlDocumentationPage />} />
          <Route path="/docs/aml" element={<AmlDocumentationPage />} />
          <Route path="/software/system-models" element={<SystemModelGuidePage />} />
          <Route path="/docs/system-models" element={<SystemModelGuidePage />} />
          <Route path="/technology" element={<TechnologyPage />} />
          <Route path="/technology/microreactors" element={<TechnologyDetailPage technology={technologyDetails.microreactors} />} />
          <Route path="/technology/nuclear-batteries" element={<TechnologyDetailPage technology={technologyDetails['nuclear-batteries']} />} />
          <Route path="/technology/energy-conversion" element={<TechnologyDetailPage technology={technologyDetails['energy-conversion']} />} />
          <Route path="/technology/radiation-systems" element={<TechnologyDetailPage technology={technologyDetails['radiation-systems']} />} />
          <Route path="/technology/research" element={<TechnologyResearchPage />} />
          <Route path="/engineering" element={<EngineeringPage />} />
          <Route path="/engineering/nuclear" element={<EngineeringDetailPage discipline={engineeringDetails.nuclear} />} />
          <Route path="/engineering/mechanical" element={<EngineeringDetailPage discipline={engineeringDetails.mechanical} />} />
          <Route path="/engineering/thermal-fluid" element={<EngineeringDetailPage discipline={engineeringDetails['thermal-fluid']} />} />
          <Route path="/engineering/electrical-controls" element={<EngineeringDetailPage discipline={engineeringDetails['electrical-controls']} />} />
          <Route path="/engineering/simulation" element={<EngineeringDetailPage discipline={engineeringDetails.simulation} />} />
          <Route path="/engineering/systems" element={<EngineeringDetailPage discipline={engineeringDetails.systems} />} />
          <Route path="/engineering/verification" element={<EngineeringDetailPage discipline={engineeringDetails.verification} />} />
          <Route path="/investors" element={<InvestorsPage />} />
          <Route path="/investors/materials" element={<InvestorMaterialsPage />} />
          <Route path="/investors/data-room" element={<DataRoomPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/shop/cart" element={<ShopCartPage />} />
          <Route path="/shop/checkout" element={<ShopCheckoutPage />} />
          <Route path="/shop/:category" element={<ShopPage />} />
          <Route path="/shop/:category/:slug" element={<ShopProductPage />} />
          {routes.filter(route => route.path !== '/account/create').map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={<PlaceholderPage eyebrow={route.label} title={route.title} />}
            />
          ))}
          <Route path="*" element={<PlaceholderPage eyebrow="404" title="Page not found" />} />
        </Route>
      </Routes>
    </CartProvider></AuthProvider>
  )
}
